"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LazyBurgerMenuContent = void 0;
var _react = require("react");
var _CataloguesSkeleton = require("../Catalogues/CataloguesSkeleton");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); } // istanbul ignore file @preserve -- lazy component render
const BurgerMenuContent = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "TopArea_BurgerMenuContent" */'./BurgerMenuContent')))).BurgerMenuContent
}));
const LazyBurgerMenuContent = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
  fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CataloguesSkeleton.CataloguesSkeleton, {}),
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(BurgerMenuContent, {})
});
exports.LazyBurgerMenuContent = LazyBurgerMenuContent;
